import { useMemo } from "react";

export default function useFilterFields(fieldList, search, labelIndex = 2) {
  return useMemo(() => {
    if (!search?.trim()) return fieldList;

    return fieldList.filter(field => {
      const searchLower = search.toLowerCase();
      const label = field[labelIndex];
      return (
        label &&
        label
          .toString()
          .toLowerCase()
          .includes(searchLower)
      );
    });
  }, [fieldList, search, labelIndex]);
}
